import type { ReceiptTemplate } from '../schema';

export const targetTemplate: ReceiptTemplate = {
  id: 'target',
  name: 'Target Receipt',
  brand: 'Target',
  description: 'Retail receipt template inspired by Target stores',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'target-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/target.png',
        logoData: '',
        logoWidth: 200,
        logoHeight: 85,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'Monsterville - 510-555-0127',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
        ],
        showDivider: false,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'target-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: '06/06/2021 08:57 PM',
        format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'target-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '12345678904849981651651123',
        showValue: false,
        width: 1.2,
        height: 20,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'target-grocery-label',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'GROCERY',
        fontSize: 12,
        isBold: true,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'target-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: false,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item',
          amount: 'Price',
        },
        items: [
          { id: 'target-item-1', name: '270030028 AVOCADO        BF', price: '$0.95' },
          { id: 'target-item-2', name: '211180116 GV MILK 2%     BF', price: '$3.64' },
          { id: 'target-item-3', name: '284060377 GV BREAD WH    BF', price: '$1.28' },
          { id: 'target-item-4', name: '284000087 GV EGGS LG     BF', price: '$4.87' },
          { id: 'target-item-5', name: '284050333 TIDE PODS      TF', price: '$14.97' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'target-divider-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: 'target-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 0,
        lines: [
          { id: 'target-subtotal', label: 'SUBTOTAL', value: '25.71', isBold: false, isLarge: false },
          { id: 'target-tax-b', label: 'B = TN TAX 6.75000 on $10.74', value: '0.72', isBold: false, isLarge: false },
          { id: 'target-tax-t', label: 'T = TN TAX 9.75000 on $14.97', value: '1.46', isBold: false, isLarge: false },
          { id: 'target-total', label: 'TOTAL', value: '27.89', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'target-auth',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'target-aid-empty', label: '', value: '' },
          { id: 'target-authcode-empty', label: '', value: '' },
        ],
        column2: [
          { id: 'target-aid', label: 'A10:', value: 'A0000000031010' },
          { id: 'target-authcode', label: 'AUTH CODE:', value: '059746' },
        ],
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'target-divider-3',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 10,
      },
    },
    {
      id: 'target-circle',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Your Target Circle earnings are in!\nOpen the Target App or visit\nTarget.com/Circle to see your benefits.',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'target-divider-4',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 24,
      },
    },
    {
      id: 'target-divider-dashed',
      type: 'divider',
      enabled: true,
      config: {
        style: 'dashed',
        spacing: 4,
      },
    },
    {
      id: 'target-savings',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TOTAL SAVINGS THIS TRIP\n$0.00',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'target-divider-dashed-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'dashed',
        spacing: 4,
      },
    },
    {
      id: 'target-bottom-spacer',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 24,
      },
    },
  ],
};
